/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDataAvailability } from './businessObjectDataAvailability';


export interface BusinessObjectDataAvailabilityCollectionResponse { 
    /**
     * A container for the availability responses
     */
    businessObjectDataAvailabilityResponses?: Array<BusinessObjectDataAvailability>;
    /**
     * Aggregate response indicating if all of the data covered in all requests in the collection is available
     */
    isAllDataAvailable?: boolean;
    /**
     * Aggregate response indicating if none of the data covered in any request in the collection is available
     */
    isAllDataNotAvailable?: boolean;
}
